/**
 * 图片优化方法，集合了webp、尺寸裁剪、q压缩的能力。
 * 其中尺寸裁剪，由于图片来源分为fileServer与tps两种类型，因此需要按类型进行裁剪。
 * fileServer的尺寸支持标准：https://yuque.antfin-inc.com/market_infrastructure/po7rv6/za52rd
 * TPS的尺寸支持标准：http://baike.corp.taobao.com/index.php/CS_RD/tfs/http_server
 * @param {string} img 图片地址
 * @param {number} size 如果是fileserver的图片（路径特点：sc01/sc02.alicdn.com/kf/...），需要裁剪到的尺寸大小，默认不裁剪。
 * @param {boolean} xz 图片是否做正方形裁剪，默认false。产品图建议为true，非产品图建议false
 * @param {number} tpsSize 如果是tps的图片路径特点：img/gw.alicdn.com/tfs/...），需要裁剪到的尺寸大小，默认不裁剪。
 * @param {number} quality 图片q压缩大小。建议值80。默认不压缩。
 * @returns 处理后的图片URL
 */

const canProcessList = [
  /\/\/sc0[1234]\.alicdn\.com/,
  /\/\/s\.alicdn\.com\/@sc0[1234]/,
  /\/\/(img|gw)\.alicdn\.com/,
  /\/\/s\.alicdn\.com\/@img/,
  /\/\/(ossgw)\.alicdn\.com/,
  /\/\/s\.alicdn\.com\/@ossgw/,
];

function parseImage({
  img,
  size,
  xz,
  tpsSize,
  quality,
}: {
  img: string;
  size?: number;
  xz?: boolean;
  tpsSize?: number;
  quality?: number;
}) {
  // 先处理图片后缀
  let url = img ? img.replace(/_\d+x\d+(xz)?(q\d+)?\.(png|jpg|jpeg)(_\.webp)?/, '') : '';
  url = url.replace(/http(s?):/g, '');
  let realSize = null;

  // 只处理域名在白名单内的图片，否则原样返回
  let canProcess = false;
  canProcessList.forEach((testCase) => {
    if (testCase.test(url)) {
      canProcess = true;
    }
  });
  if (!canProcess) return url;

  if (/\/\/(sc01|sc02|sc03|sc04|img|gw|ossgw)\.alicdn\.com/.test(url)) {
    const matches = url.match(/(sc01|sc02|sc03|sc04|img|gw|ossgw).alicdn.com/);
    if (matches && matches.length >= 2) {
      const replaceStr = matches[1] === 'gw' ? 'img' : matches[1];
      url = url.replace(
        /(sc01|sc02|sc03|sc04|img|gw|ossgw).alicdn.com/,
        `s.alicdn.com/@${replaceStr}`,
      );
    }
  }

  if (/\/\/s\.alicdn\.com\/@sc0[1234]/.test(url)) {
    realSize = size;
  } else if (/\/\/s\.alicdn\.com\/@img/.test(url)) {
    realSize = tpsSize || size;
  } else if (/\/\/s\.alicdn\.com\/@ossgw/.test(url) && !/x-oss-process/.test(url)) {
    // ossgw的图片只做尺寸裁剪，不做quality控制
    const finalSize = size && tpsSize ? Math.min(size, tpsSize) : size || tpsSize;
    return `${url}?x-oss-process=image/resize,l_${finalSize},limit_1/`;
  }

  // .gif格式只做i.alicdn.com的转发，不做其他处理
  if (/.gif/.test(url)) {
    return url;
  }

  let afterfix = '';
  if (realSize) {
    afterfix = realSize ? `_${realSize}x${realSize}` : '';
  }
  if (xz) {
    afterfix += afterfix ? 'xz' : '';
  }
  if (quality) {
    afterfix += afterfix ? `q${quality}` : `_q${quality}`;
  }

  url = afterfix ? `${url}${afterfix}.jpg` : url;

  return url;
}
export default parseImage;
